import { useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { DialogUtility } from '@syncfusion/ej2-react-popups';
import EditorTemplate from './EditorTemplate';
import EditorFooterTemplate from './EditorFooterTemplate';
import { readFormChecked } from './schedulerForm.js';
import { saveSchedulerEvent } from './CoachScheduleActions.js';

const editorTarget = (mode) => ({
    classList: {
        contains: (name) => mode === 'Save' && name === 'e-appointment',
    },
});

const SchedulerEditorDialog = ({
    session,
    userInfo,
    selectedClub,
    events,
    courtData,
    calenderConfig,
    players,
    privileges,
    scheduleRef,
    setIsRefresh,
    dispatch,
    onClose,
}) => {
    const formRef = useRef(null);
    const [formError, setFormError] = useState('');
    const data = session?.data || {};
    const mode = session?.mode || 'Add';

    const save = async () => {
        const error = await saveSchedulerEvent({
            element: formRef.current,
            data,
            Id: data.Id,
            target: editorTarget(mode),
        }, scheduleRef, userInfo, selectedClub, setIsRefresh, dispatch, calenderConfig, onClose);
        if (error) {
            setFormError(error);
        }
    };

    const requestSave = () => {
        if (readFormChecked(formRef.current, '#is_rsvp') && data.Id) {
            const dialogObj = DialogUtility.confirm({
                title: 'Warning',
                content: 'If you update rsvp schedule then all rsvp requests are reset',
                width: '300px',
                position: { X: 'center', Y: 'center' },
                animationSettings: { effect: 'Zoom' },
                cssClass: 'fixthis',
                okButton: {
                    click: () => {
                        save();
                        dialogObj.hide();
                    },
                },
                cancelButton: {
                    click: () => dialogObj.hide(),
                },
            });
            return;
        }
        save();
    };

    return createPortal(
        <div className="sm-scheduler-editor-overlay" data-testid="scheduler-editor-dialog">
            <div className="sm-scheduler-editor-dialog" role="dialog" aria-labelledby="sm-scheduler-editor-title">
                <div className="sm-scheduler-editor-header">
                    <h2 id="sm-scheduler-editor-title">{data.Id ? 'Edit schedule' : 'Add schedule'}</h2>
                    <button type="button" className="sm-scheduler-editor-close" onClick={onClose} aria-label="Close">
                        ×
                    </button>
                </div>
                <div className="sm-scheduler-editor-body" ref={formRef}>
                    <EditorTemplate
                        args={data}
                        userInfo={userInfo}
                        clubId={selectedClub?.clubId}
                        events={events}
                        courtData={courtData}
                        calenderConfig={calenderConfig}
                        players={players}
                        formError={formError}
                    />
                </div>
                <EditorFooterTemplate
                    args={data}
                    privileges={privileges}
                    selectedClub={selectedClub}
                    scheduleRef={{ current: { closeEditor: onClose } }}
                    setIsRefresh={setIsRefresh}
                    onSave={requestSave}
                    onClose={onClose}
                />
            </div>
        </div>,
        document.body
    );
};

export default SchedulerEditorDialog;
